import { useEffect, useState } from "react"
import AnimatedLetters from "../../AnimatedLetters/AnimatedLetters"
import YoutubeCard from "../../Cards/YoutubeCard/YoutubeCard"
import "./reactTips.scss"
import Loader from "react-loaders"

function ReactTips() {
    const [letterClass, setLetterClass] = useState('text-animate')

    useEffect(() => {
        setTimeout(() => {
            setLetterClass('text-animate-hover')
        }, 3000)
    }, [])

    return (
        <>
            <div className="container reactTips-page">
                <div className="text-zone">
                    <h1>
                        <AnimatedLetters
                            letterClass={letterClass}
                            strArray={["R", "e", "a", "c", "t", " ", "T", "i", "p", "s"]}
                            idx={15}
                        />
                    </h1>
                </div>
                <div className="card-container">
                    <div className="card-info">
                        <YoutubeCard header="SVG Animation in 10 Minutes" source="ZG3H729ZCTE" />
                    </div>
                </div>
            </div>
            <Loader type="pacman" />
        </>
    )
}

export default ReactTips